import Vue from 'vue'
import Router from 'vue-router'
import VueGtag from 'vue-gtag'
import { store } from '@/store/store'
import axios from 'axios'

// import { temAcesso } from '@/shared/auth/temAcesso'

import controleAcessoRotas from '@/app/ctrlacesso/ControleAcessoRotas'
import fornecedorRotas from '@/app/fornecedor/FornecedorRotas'
import dirfsRotas from '@/app/dirfs/DirfsRotas'
import atualizacoesCadastraisRotas from '@/app/atualizacoescadastrais/AtualizacoesCadastraisRotas'
import fornecedoresRotas from '@/app/fornecedores/FornecedoresRotas'
import mensagensRotas from '@/app/mensagens/MensagensRotas'
import pesquisasRotas from '@/app/pesquisas/PesquisasRotas'
import adminRotas from '@/app/admin/AdminRotas'
import relatoriosRotas from '@/app/relatorios/RelatoriosRotas'
import baseConhecimentoRotas from '@/app/baseconhecimento/BaseConhecimentoRotas'
import gesconRotas from '@/app/gescon/GesconRotas'
import propostasPrecosRotas from '@/app/propostasprecos/PropostasPrecosRotas'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// App
const Dashboard = () => import('@/app/dashboard/Dashboard')
const Login = () => import('@/app/ctrlacesso/login/Login')
const EsqueciMinhaSenha = () =>
    import('@/app/ctrlacesso/login/EsqueciMinhaSenha')
const SolicitacaoAcesso = () =>
    import('@/app/ctrlacesso/solicitacoesacesso/SolicitacaoAcesso')
const AtualizarSenha = () => import('@/app/ctrlacesso/usuarios/AtualizarSenha')
const ErroPadrao = () => import('@/shared/components/ErroPadrao')
const ErroNaoAutorizado = () => import('@/shared/components/ErroNaoAutorizado')

Vue.use(Router)

const routes = [
    {
        path: '/',
        name: 'Home',
        redirect: '/dashboard',
        component: DefaultContainer,
        beforeEnter: (to, from, next) => {
            if (store.getters.estaAutenticado) {
                next()
            } else {
                store.dispatch('tryAutoLogin')
                if (store.getters.estaAutenticado) {
                    next()
                } else {
                    next('/login')
                }
            }
        },
        children: [
            {
                path: 'dashboard',
                name: 'Dashboard',
                component: Dashboard
            },
            controleAcessoRotas,
            fornecedorRotas,
            dirfsRotas,
            atualizacoesCadastraisRotas,
            fornecedoresRotas,
            mensagensRotas,
            adminRotas,
            relatoriosRotas,
            baseConhecimentoRotas,
            pesquisasRotas,
            gesconRotas,
            propostasPrecosRotas,
        ]
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        children: [
            {
                path: 'interno',
                name: 'LoginInterno',
                component: Login
            }
        ]
    },
    {
        path: '/solicitacaoacesso',
        name: 'solicitacaoacesso',
        component: SolicitacaoAcesso
    },
    {
        path: '/esqueciminhasenha',
        name: 'EsqueciMinhaSenha',
        component: EsqueciMinhaSenha
    },
    {
        path: '/atualizarsenha',
        name: 'AtualizarSenha',
        component: AtualizarSenha
    },
    {
        path: '/erro',
        name: 'Erro',
        component: ErroPadrao
    },
    {
        path: '/naoautorizado',
        name: 'Erro_NaoAutorizado',
        component: ErroNaoAutorizado
    }
]

const router = new Router({
    mode: 'hash',
    linkActiveClass: 'open active',
    scrollBehavior: () => ({
        y: 0
    }),
    routes: routes
})

axios.get('app/analytics.txt').then((res) => {
    Vue.use(
        VueGtag,
        {
            config: {
                id: `${res.data}`
            }
        },
        router
    )
});

export default router

// export default new Router({
//   mode: 'hash', // https://router.vuejs.org/api/#mode
//   linkActiveClass: 'open active',
//   scrollBehavior: () => ({ y: 0 }),
//   routes: [
//     {
//       path: '/',
//       redirect: '/dashboard',
//       name: 'Home',
//       component: DefaultContainer,
//       children: [
//         {
//           path: 'dashboard',
//           name: 'Dashboard',
//           component: Dashboard
//         },
//         {
//           path: 'theme',
//           redirect: '/theme/colors',
//           name: 'Theme',
//           component: {
//             render (c) { return c('router-view') }
//           },
//           children: [
//             {
//               path: 'colors',
//               name: 'Colors',
//               component: Colors
//             },
//             {
//               path: 'typography',
//               name: 'Typography',
//               component: Typography
//             }
//           ]
//         },
//         {
//           path: 'charts',
//           name: 'Charts',
//           component: Charts
//         },
//         {
//           path: 'widgets',
//           name: 'Widgets',
//           component: Widgets
//         },
//         {
//           path: 'users',
//           meta: { label: 'Users'},
//           component: {
//             render (c) { return c('router-view') }
//           },
//           children: [
//             {
//               path: '',
//               component: Users,
//             },
//             {
//               path: ':id',
//               meta: { label: 'User Details'},
//               name: 'User',
//               component: User,
//             },
//           ]
//         },
//         {
//           path: 'base',
//           redirect: '/base/cards',
//           name: 'Base',
//           component: {
//             render (c) { return c('router-view') }
//           },
//           children: [
//             {
//               path: 'cards',
//               name: 'Cards',
//               component: Cards
//             },
//             {
//               path: 'forms',
//               name: 'Forms',
//               component: Forms
//             },
//             {
//               path: 'switches',
//               name: 'Switches',
//               component: Switches
//             },
//             {
//               path: 'tables',
//               name: 'Tables',
//               component: Tables
//             },
//             {
//               path: 'tabs',
//               name: 'Tabs',
//               component: Tabs
//             },
//             {
//               path: 'breadcrumbs',
//               name: 'Breadcrumbs',
//               component: Breadcrumbs
//             },
//             {
//               path: 'carousels',
//               name: 'Carousels',
//               component: Carousels
//             },
//             {
//               path: 'collapses',
//               name: 'Collapses',
//               component: Collapses
//             },
//             {
//               path: 'jumbotrons',
//               name: 'Jumbotrons',
//               component: Jumbotrons
//             },
//             {
//               path: 'list-groups',
//               name: 'List Groups',
//               component: ListGroups
//             },
//             {
//               path: 'navs',
//               name: 'Navs',
//               component: Navs
//             },
//             {
//               path: 'navbars',
//               name: 'Navbars',
//               component: Navbars
//             },
//             {
//               path: 'paginations',
//               name: 'Paginations',
//               component: Paginations
//             },
//             {
//               path: 'popovers',
//               name: 'Popovers',
//               component: Popovers
//             },
//             {
//               path: 'progress-bars',
//               name: 'Progress Bars',
//               component: ProgressBars
//             },
//             {
//               path: 'tooltips',
//               name: 'Tooltips',
//               component: Tooltips
//             }
//           ]
//         },
//         {
//           path: 'buttons',
//           redirect: '/buttons/standard-buttons',
//           name: 'Buttons',
//           component: {
//             render (c) { return c('router-view') }
//           },
//           children: [
//             {
//               path: 'standard-buttons',
//               name: 'Standard Buttons',
//               component: StandardButtons
//             },
//             {
//               path: 'button-groups',
//               name: 'Button Groups',
//               component: ButtonGroups
//             },
//             {
//               path: 'dropdowns',
//               name: 'Dropdowns',
//               component: Dropdowns
//             },
//             {
//               path: 'brand-buttons',
//               name: 'Brand Buttons',
//               component: BrandButtons
//             }
//           ]
//         },
//         {
//           path: 'icons',
//           redirect: '/icons/font-awesome',
//           name: 'Icons',
//           component: {
//             render (c) { return c('router-view') }
//           },
//           children: [
//             {
//               path: 'coreui-icons',
//               name: 'CoreUI Icons',
//               component: CoreUIIcons
//             },
//             {
//               path: 'flags',
//               name: 'Flags',
//               component: Flags
//             },
//             {
//               path: 'font-awesome',
//               name: 'Font Awesome',
//               component: FontAwesome
//             },
//             {
//               path: 'simple-line-icons',
//               name: 'Simple Line Icons',
//               component: SimpleLineIcons
//             }
//           ]
//         },
//         {
//           path: 'notifications',
//           redirect: '/notifications/alerts',
//           name: 'Notifications',
//           component: {
//             render (c) { return c('router-view') }
//           },
//           children: [
//             {
//               path: 'alerts',
//               name: 'Alerts',
//               component: Alerts
//             },
//             {
//               path: 'badges',
//               name: 'Badges',
//               component: Badges
//             },
//             {
//               path: 'modals',
//               name: 'Modals',
//               component: Modals
//             }
//           ]
//         }
//       ]
//     },
//     {
//       path: '/pages',
//       redirect: '/pages/404',
//       name: 'Pages',
//       component: {
//         render (c) { return c('router-view') }
//       },
//       children: [
//         {
//           path: '404',
//           name: 'Page404',
//           component: Page404
//         },
//         {
//           path: '500',
//           name: 'Page500',
//           component: Page500
//         },
//         {
//           path: 'login',
//           name: 'Login',
//           component: Login
//         },
//         {
//           path: 'register',
//           name: 'Register',
//           component: Register
//         }
//       ]
//     }
//   ]
// })
